import { useState, useEffect } from "react";

export default function useCounter(target, dur = 1800, run = false) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!run) return;
    const step = target / (dur / 16);
    let cur = 0;
    const id = setInterval(() => {
      cur += step;
      if (cur >= target) { setVal(target); clearInterval(id); }
      else setVal(Math.floor(cur));
    }, 16);
    return () => clearInterval(id);
  }, [run, target, dur]);
  return val;
}
